import styled from "styled-components";

const JourneySectionContainer = styled.div`
  display: flex;
  justify-content: space-between;
  background-color: ${({ theme }) => theme.colors.baseWhite};
  padding: 24px 0;
  border-top: 1px solid ${({ theme }) => theme.colors.base3};
  border-bottom: 1px solid ${({ theme }) => theme.colors.base3};

  @media all and (max-width: ${({ theme }) => theme.mobileBreakingPoint}) {
    position: relative;
    height: 200px;
    padding: 16px 32px;
    box-sizing: border-box;
  }
`;

export default JourneySectionContainer;
